import Vuex from 'vuex'
import Vue from 'vue'
// import axios from 'axios'

//
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    progress: 0,
    background_videos: [],
    nbVideos: 13,
    loaded: false,
    selectedVideo: 0
  },


  mutations: {
    increment (state) {
      state.progress += Math.round(100 / state.nbVideos)
    },
    isLoaded(state) {
      state.loaded = true
    },
    changeVideo(state, vid) {
      state.selectedVideo = vid
    }
  },
  
  actions: {
    /*
    downloadVideo({ commit }, data) {
      axios
      .get('videos/lowbitrate/' + data.videoUrl)
      .then(function() {
          commit('increment')
      })
    }
    */
  }
})
